import { render, staticRenderFns } from "./PurchaseOrderListSideMenu.vue?vue&type=template&id=baa527d6"
import script from "./PurchaseOrderListSideMenu.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderListSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('baa527d6')) {
      api.createRecord('baa527d6', component.options)
    } else {
      api.reload('baa527d6', component.options)
    }
    module.hot.accept("./PurchaseOrderListSideMenu.vue?vue&type=template&id=baa527d6", function () {
      api.rerender('baa527d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderListSideMenu.vue"
export default component.exports